import React from 'react';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';

/**
 * TrendBadge - Displays a percentage trend with directional arrow and color.
 */
const TrendBadge = ({ value, label, size = 'md' }) => {
    const num = Number(value) || 0;
    const isPositive = num > 0;
    const isNeutral = num === 0;

    const sizeClass = `sd-trend-badge--${size}`;
    const directionClass = isPositive
        ? 'sd-trend-badge--up'
        : isNeutral
            ? 'sd-trend-badge--neutral'
            : 'sd-trend-badge--down';

    const iconSize = size === 'sm' ? 10 : size === 'lg' ? 14 : 12;

    const Icon = isPositive ? ArrowUp : isNeutral ? Minus : ArrowDown;
    const sign = isNeutral ? '' : isPositive ? '+' : '';
    const formattedValue = `${sign}${num.toFixed(1)}%`;

    return (
        <span className={`sd-trend-badge ${directionClass} ${sizeClass}`}>
            <Icon size={iconSize} />
            <span>{formattedValue}</span>
            {label && <span className="sd-trend-badge__label">{label}</span>}
        </span>
    );
};

export default TrendBadge;
